import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import {
  environmentalChecklistItem,
  environmentalChecklistItemWithTicket,
} from "../../../../schemas";

export const resEnvChecklistLaundrySchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  laundryWasher: environmentalChecklistItemWithTicket,
  laundryDryerExterior: environmentalChecklistItemWithTicket,
  laundryDryerInterior: environmentalChecklistItem,
  laundryFloor: environmentalChecklistItem,
  laundryCeiling: environmentalChecklistItemWithTicket,
  laundryWindows: environmentalChecklistItemWithTicket,
  laundryLinenCovered: environmentalChecklistItem,
  laundryDetergent: environmentalChecklistItem,
  laundryStorageClean: environmentalChecklistItem,
  laundryComment: z.string().optional(),
});
